module.exports = __webpack_public_path__ + "img/teams_competition.daf6fd04.png";